<template>
  <div class="box auth forget">
    <div class="form">
      <h1 class="box__title">Get a new one!</h1>
      <p class="box__intro">Can't remember your Password?<br/>No Problem, set a new one:.</p>
      <div class="form-group">
        <label for="password">{{ $t('auth.password')}}</label>
        <input type="password" class="form-control" id="password"  v-model="password" required>
      </div>

      <div class="form-group">
        <label for="password_confirmation">{{ $t('auth.passwordconfirm')}}</label>
        <input type="password" class="form-control" id="password_confirmation"  v-model="password_confirmation" required>
      </div>

      <div>
        <div class="action d-flex justify-content-center">
          <button v-bind:disabled="!formValid" type="submit" class="btn btn-primary btn-big" @click="submitForm">
            {{ $t('auth.resetpassword')}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import mixins from '../mixins'

export default {
  name: 'Resetpassword',

  mixins: [mixins],

  computed: {
    formValid () {
      return this.password !== '' && this.password_confirmation !== '' && this.password_confirmation === this.password
    }
  },

  data () {
    return {
      password: '',
      password_confirmation: ''
    }
  },

  methods: {

    ...mapActions('user', ['resetPassword']),

    submitForm () {
      const payload = {
        password: this.password,
        password_confirmation: this.password_confirmation,
        email: this.$route.query.email,
        token: this.$route.query.token
      }

      this.resetPassword(payload).then(() => {
        this.$router.push('/login')
      }).catch(() => {
        this.$router.push('/login')
      })
    }
  }
}
</script>
